import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import { getEmKeycloakUsersRequest } from '../accessManagement/reducer';
import {
	TConnectedEmerchantsRequest,
	TConnectedEmerchantsResponsePayload,
	TDetachEmKeycloakUserRequest,
} from './types';
import {
	getUserMgmtConnectedEmerchantsRequest,
	getUserMgmtConnectedEmerchantsSuccess,
	getUserMgmtConnectedEmerchantsFailure,
	detachUserMgmtEmUserRequest,
	detachUserMgmtEmUserSuccess,
	detachUserMgmtEmUserFailure,
} from './reducer';

function* getUserMgmtConnectedEmerchantsWorker({
	payload,
}: PayloadAction<TConnectedEmerchantsRequest>) {
	try {
		const response: TConnectedEmerchantsResponsePayload = yield call(
			api.accessManagement.getConnectedEmerchants,
			payload,
		);
		yield put(getUserMgmtConnectedEmerchantsSuccess(response));
	} catch (error) {
		yield put(getUserMgmtConnectedEmerchantsFailure());
		if (axios.isAxiosError(error)) {
			// silent fail, same as original
		}
	}
}

function* detachUserMgmtEmUserWorker({ payload }: PayloadAction<TDetachEmKeycloakUserRequest>) {
	try {
		yield call(api.accessManagement.detachEmUser, payload.body);
		yield put(detachUserMgmtEmUserSuccess());
		notificationContainer('User detached successfully', 'success');

		if (payload.getEmKeycloakUsers) {
			yield put(getEmKeycloakUsersRequest(payload.getEmKeycloakUsers));
		}
		yield put(getUserMgmtConnectedEmerchantsRequest({ email: payload.body.email }));
	} catch (error) {
		yield put(detachUserMgmtEmUserFailure());
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data?.message ?? 'Error'), 'error');
		}
	}
}

export function* userMgmtConnectedEmerchantsSaga() {
	yield takeEvery(getUserMgmtConnectedEmerchantsRequest.type, getUserMgmtConnectedEmerchantsWorker);
	yield takeEvery(detachUserMgmtEmUserRequest.type, detachUserMgmtEmUserWorker);
}
